import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { EPAHoldingQueueCount } from "../../Apis/AuthApiServices";
import {
  loadingEPAHoldingQueueCount,
  setEPAHoldingQueueCount,
} from "../Slice/EPAHoldingQueueCountSlice";

function* onLoadEPAHoldingQueueCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("prescriptionType", payload.prescriptionType);
  try {
    const result: AxiosResponse = yield EPAHoldingQueueCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setEPAHoldingQueueCount({
          EPAHoldingQueueCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setEPAHoldingQueueCount({
          EPAHoldingQueueCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setEPAHoldingQueueCount({
        EPAHoldingQueueCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadEPAHoldingQueueCount() {
  yield takeLatest(
    loadingEPAHoldingQueueCount.type,
    onLoadEPAHoldingQueueCountAsync
  );
}

const EPAHoldingQueueCountSaga = [fork(onLoadEPAHoldingQueueCount)];
export default EPAHoldingQueueCountSaga;
